// extracted by mini-css-extract-plugin
module.exports = {"hiddenTokenButton":"styles_hiddenTokenButton__r9wXV"};